import React from 'react'

interface IDiscountBadgeProps {
    price: number
    discountedPrice: number
}

const discountInPercentage = (price: number, discountedPrice: number) =>
    Math.floor(((price - discountedPrice) / price) * 100)

const colorsByDiscount = (discount: number) => {
    if (discount >= 50) return 'bg-stylish-yellow text-white text-xs font-bold'
    if (discount >= 25) return 'bg-stylish-yellow-light text-white text-xs font-bold'
    return 'bg-white text-stylish-yellow text-xs font-bold'
}

/** Selo "N% OFF" do card e da PDP; não aparece sem desconto. */
const DiscountBadge: React.FC<IDiscountBadgeProps> = ({ price, discountedPrice }) => {
    if (!discountedPrice || discountedPrice >= price) return null

    const discount = discountInPercentage(price, discountedPrice)

    return (
        <div
            className={`flex items-center justify-center z-20
      right-4 top-4 px-[10px] py-1 border-0 rounded-full w-fit max-sm:py-4
      ${colorsByDiscount(discount)}  absolute  h-6`}
        >
            <p className="max-sm:text-lg">{discount}% OFF</p>
        </div>
    )
}

export default DiscountBadge
